search_strings = {"products":{"en":"Products","ja":"商品"},"collections":{"en":"Collections","ja":"コレクション"},"view_all_products_start":{"en":"View all ","ja":"すべての商品("},"view_all_products_end":{"en":" products","ja":"個)を見る"},"no_results_start":{"en":"No results for ","ja":""},"no_results_end":{"en":"","ja":"に一致するものが見つかりませんでした。"},"coming_soon":{"en":"Coming soon!","ja":"近日取扱開始"},"not_available":{"en":"Not available","ja":"利用不可"},"glitch_sale":{"en":"Glitch Sale exclusive!","ja":"訳ありセール限定！"},"on_kickstarter":{"en":"On Kickstarter!","ja":"Kickstarterの商品！"}};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expand = 1000;

document.addEventListener('lazybeforeunveil', function(e){
  var bg = e.target.getAttribute('data-bg');
  if (bg) {
    e.target.style.backgroundImage = 'url(' + bg + ')';
  }
});

SVGInject.setOptions({
  onFail: function(img, svg) {
    img.classList.remove('injectable');
  },
  onAllFinish: function() {
    $('svg.injectable').removeAttr('id');
    $('svg.injectable').find('*').removeAttr('id');
  }
});

Fancybox.bind("[data-fancybox], .fancybox", {
  Toolbar: {
    display: [
      "close",
    ],
  }
});

var is_touch_device = ("ontouchstart" in window) || window.DocumentTouch && document instanceof DocumentTouch;
var is_edge = (window.navigator.userAgent.indexOf("Edge") > -1);

$(function () {
  SVGInject(document.querySelectorAll('img.injectable'));

  $('.navbar .dropdown').on("mouseenter", function() {
    $('body').addClass('show-fade-bg');
  });

  $('.navbar .dropdown').on("mouseleave", function(e) {
    if ($('#top_nav .dropdown.dropdown-hover.show').length == 0) {
      $('body').removeClass('show-fade-bg');
    }
  });

  $('#body-container-cover').on("touchmove", function(e) {
    e.preventDefault();
  });

  if (!is_touch_device) {
    $('[data-toggle="popover"]').popover();
  }
  $('[data-toggle="tooltip"]').tooltip();

  if (!is_edge) {
    $('.edge-only').remove();
  }
  
  $(document).on('click', '#body-container-cover, .close-drawers',function(e){
    $('body, html, #body-container, #left-drawer, #right-drawer').removeClass('drawer-left-open').removeClass('drawer-right-open');
    $("#left-drawer").attr("aria-expanded", false).removeAttr('role');
    $("#right-drawer").attr("aria-expanded", false).removeAttr('role');
    $('body').removeClass('show-fade-bg');
    $('#main').focus();
  });
  
  $(document).on('click','#menu-xs',function(e){
    $('body, html, #body-container, #left-drawer').toggleClass('drawer-left-open');
    if ($('.drawer-left-open').length > 0) {
      $("#left-drawer").attr("aria-expanded", true).attr('role', 'dialog');
      $("#left-drawer").focus();
    } else {
      $("#left-drawer").attr("aria-expanded", false).removeAttr('role');
      $('body').removeClass('show-fade-bg');
    }
  });

  $(document).on('hidden.bs.dropdown', '#top_nav .dropdown', function() {
    if ($('.nav-item.show').length == 0) {
      $('body').removeClass('show-fade-bg');
    }
  });

  $(document).on('click','.show-cart',function(e){
    e.preventDefault();
    $('body, html, #body-container, #right-drawer').toggleClass('drawer-right-open');
    if ($('.drawer-right-open').length > 0) {
      $("#right-drawer").attr("aria-expanded", true).attr('role', 'dialog');
      $("#right-drawer").focus();
    } else {
      $("#right-drawer").attr("aria-expanded", false).removeAttr('role');
      $('body').removeClass('show-fade-bg');
    }
  });

  $(document).on('click','#top_alert, .popover',function(e){
    if (e.target.nodeName == 'A') return;
    $('#top_alert').popover('toggle');
  });

  $(document).on('DOMNodeInserted', '.junip-step', function() {
    if ($('.junip-added-helptext').length == 0) {
      $('.junip-textfield[autocomplete="name"]').closest('form:not(.junip-tweaked)').addClass('junip-tweaked').after("<div class='junip-added-helptext'>Your first name and last initial will be displayed next to your review</div>");
      $('.junip-textfield[autocomplete="email"]').closest('form:not(.junip-tweaked)').addClass('junip-tweaked').after("<div class='junip-added-helptext'>Your email will be kept privately and securely. It will only be used in case we need to contact you about your review</div>");
    }
  });

  var clearing = false;

  $(document).on('click','.clear-cart',function(){
    if (clearing) {
      return;
    }
    $.ajax({
      url: "/cart/clear.js",
      type: "POST",
      dataType: "json",
      beforeSend: function() {
        clearing = true;
        $(".clear-cart").prop("disabled",true).addClass('disabled').html("<i class='icon icon-spinner-third icon-spin'></i>")
      },
      success: function(data,textStatus,xhr){
        setTimeout(function(){
          location.reload()
        },50);
      },
      error: function(xhr,textStatus,errorThrown) {
        clearing = false;
        $(".clear-cart").prop("disabled",false).removeClass('disabled').html("Error")
        console.log("Error");
        console.log(xhr);
        console.log(textStatus);
        console.log(errorThrown);
      }
    })
  });

  $(document).on("click",".clear-item",function(){
    $(this).html("<span class='icon icon-spinner-third icon-spin'></span>").addClass('disabled').attr('disabled', true);
    $(this).closest('.line-item').css('opacity', 0.5);
    var updates = {};
    updates[$(this).data('variantid')] = 0;
    $.ajax({
      url:"/cart/update.json",
      dataType:'json',
      type:"POST",
      data: {
        updates: updates
      },
      success:function(data,textStatus,xhr){
        refreshCart();
      }
    });
  });

  function refreshCart() {
    $.ajax({
      url: '/pages/cart-items',
      type: 'GET',
      success: function(data) {
        $('#mini_cart_items').html(data);
        $("#mini_cart_item_count").html($("#new_cart_item_count").html());
        $("#nav_cart_count").html($("#new_cart_nav_item_count").html());
      }
    });
  }

  // Search autocomplete
  var currentAjaxRequest = null;
  var searchForms = $('form[action="/search"]').each(function() {
    var input = $(this).find('input[name="q"]');
    var offSet = input.position().top + input.innerHeight() + 25;
    $('<div class="search-results-box"><div class="popout-arrow"><div class="outer"></div></div><ul class="search-results"></ul></div>').css( { 'position': 'absolute', 'right': '0px', 'top': offSet } ).appendTo($(this)).hide();
    input.attr('autocomplete', 'off').bind('keyup focusin', function(e) {
      if (e.keyCode == 40) {
        e.preventDefault();
        $('.result a').first().focus();
      } else {
        var searchForm = $(this).closest('form');
        var resultsBox = searchForm.find('.search-results-box');
        var resultsList = searchForm.find('.search-results');
        var term = $(this).val().replace(/ +(?= )/g, '').replace(':','').trim();
        var termWords = term.split(" ");
        var fuzzyTerm = '';
        $.each(termWords, function(i, word) {
          if (word.length > 2) {
            fuzzyTerm += '*' + word + '* ';
          } else if (termWords.length > 1) {
            fuzzyTerm += '*' + word + '* ';
          }
        });
        var searchURL = '/search?type=product&options[unavailable_products]=show&q=' + fuzzyTerm.trim();

        if (term.length >= 3) {
          resultsBox.fadeIn(150);
          if (currentAjaxRequest != null) {
            currentAjaxRequest.abort();
          } else {
            resultsList.html('<li class="no-results"><span class="icon icon-spinner-third icon-spin"></span></li>');
          }
          currentAjaxRequest = $.get(searchURL + '&view=json', function(response) {
            var data = JSON.parse(response.replace('},]', '}]'));
            resultsList.empty();
            if (data.total_results == 0) {
              resultsList.html('<li class="no-results"><span>' + search_strings.no_results_start[document.documentElement.lang] + '\'' + term + '\'' + search_strings.no_results_end[document.documentElement.lang] + '</span></li>');
              resultsBox.addClass('zero-results');
            } else {
              resultsBox.removeClass('zero-results');
              if (data.collections_count > 0) {
                resultsList.append("<li class='section-header'><span>" + search_strings.collections[document.documentElement.lang] + "</span></li>");
              }
              $.each(data.collections.slice(0,3), function(index, item) {
                var link = $('<a></a>').attr('href', item.url).bind('keydown', function(e) { if (e.keyCode == 40) { e.preventDefault(); $(this).closest('.result').nextAll('.result').children('a').first().focus(); } else if (e.keyCode == 38) { e.preventDefault(); $(this).closest('.result').prevAll('.result').children('a').first().focus(); } });
                link.append(item.template);
                link.wrap('<li class="result collection-result"></li>');
                resultsList.append(link.parent());
                SVGInject(document.querySelectorAll('img.injectable'));
              });
              if (data.results_count > 0) {
                resultsList.append("<li class='section-header'><span>" + search_strings.products[document.documentElement.lang] + "</span></li>");
              }
              var productsToShow = 5;
              if (data.collections_count > 0) {
                productsToShow = 3;
              }
              $.each(data.results.slice(0,productsToShow), function(index, item) {
                var link = $('<a></a>').attr('href', item.url).bind('keydown', function(e) { if (e.keyCode == 40) { e.preventDefault(); $(this).closest('.result').nextAll('.result').children('a').first().focus(); } else if (e.keyCode == 38) { e.preventDefault(); $(this).closest('.result').prevAll('.result').children('a').first().focus(); } });
                link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
                var priceString = item.price;
                if (item.status == 'coming_soon') {
                  priceString = search_strings.coming_soon[document.documentElement.lang];
                } else if (item.status == 'not_available') {
                  priceString = search_strings.not_available[document.documentElement.lang];
                } else if (item.status == 'glitch_sale') {
                  priceString = search_strings.glitch_sale[document.documentElement.lang];
                } else if (item.status == 'on_kickstarter') {
                  priceString = search_strings.on_kickstarter[document.documentElement.lang];
                } else if (item.compare_at_price.length > 0) {
                  priceString += "<span class='compare-price' aria-hidden='true'>" + item.compare_at_price + "</span>";
                }
                link.append('<span class="product-wrapper"><span class="title">' + item.title + '</span><span class="price">' + priceString + '</span></span>');
                link.wrap('<li class="result product-result"></li>');
                resultsList.append(link.parent());
              });
              if (data.results_count > 5) {
                resultsList.append('<li><span class="view-more"><a href="' + searchURL + '">' + search_strings.view_all_products_start[document.documentElement.lang] + '<strong>' + data.results_count + '</strong>' + search_strings.view_all_products_end[document.documentElement.lang] + '</a></span></li>');
              }
            }
          });
        } else if (term.length < 3) {
          resultsBox.hide();
        }
      }
    });
  });
  $('body').bind('click', function(e){
    if (e.target.className != 'form-control') {
      $('.search-results-box').hide();
    }
  });

  // dumb hacky way of making all Shopify searches into partial searches, also redirects
  $('form[action="/search"]').submit(function(e) {
    e.preventDefault();
    
    var input = $(this).find('input[name="q"]');
    var term = input.val().replace(/ +(?= )/g,'').replace(':','').trim().toLowerCase();

    // TODO: not use hundreds of lines of nasty switch statement
    switch(term) {
      case undefined:
      case '':
        break;
      case 'undertale':
      case 'under tale':
      case 'undertake':
        window.location = '/collections/undertale';
        break;
      case 'deltarune':
        window.location = '/collections/deltarune';
        break;
      case 'bloodstained':
      case 'blood stained':
      case 'bloodstained ritual of the night':
      case 'bloodstained: ritual of the night':
        window.location = '/collections/bloodstained-ritual-of-the-night';
        break;
      case 'ftl':
        window.location = '/collections/ftl-featured';
        break;
      case 'accessories':
        window.location = '/collections/accessories';
        break;
      case 'art and posters':
        window.location = '/collections/art-posters';
        break;
      case 'art prints':
        window.location = '/collections/art-prints-1';
        break;
      case 'axiom verge':
        window.location = '/collections/axiom-verge';
        break;
      case 'books':
      case 'books and media':
      case 'media':
        window.location = '/collections/books-and-media';
        break;
      case 'buttons':
      case 'button sets':
        window.location = '/collections/button-sets';
        break;
      case 'combos':
        window.location = '/collections/combo-packs';
        break;
      case 'doublefine':
      case 'double fine':
        window.location = '/collections/double-fine';
        break;
      case 'galak z':
      case 'galakz':
        window.location = '/collections/galak-z';
        break;
      case 'game paused':
        window.location = '/collections/game-paused';
        break;
      case 'gdq':
      case 'agdq':
      case 'sgdq':
      case 'games done quick':
        window.location = '/collections/games-done-quick';
        break;
      case 'god of war':
        window.location = '/collections/god-of-war';
        break;
      case 'guacamelee':
        window.location = '/collections/guacamelee';
        break;
      case 'plushes':
      case 'plushies':
      case 'figurines':
      case 'figures':
        window.location = '/collections/handmade';
        break;
      case 'hollow knight':
      case 'hollow night':
        window.location = '/collections/hollow-knight';
        break;
      case 'home and office':
        window.location = '/collections/home-and-office';
        break;
      case 'hoodies':
      case 'outerwear':
        window.location = '/collections/hoodies';
        break;
      case 'hyperlight drifter':
      case 'hyper light drifter':
        window.location = '/collections/hyper-light-drifter';
        break;
      case 'indie mega booth':
      case 'indie megabooth':
        window.location = '/collections/indie-megabooth';
        break;
      case 'jewelry':
      case 'necklaces':
      case 'pendants':
      case 'earrings':
        window.location = '/collections/jewelry';
        break;
      case 'jon kay':
      case 'jon k':
      case 'jonk':
        window.location = '/collections/jonkay';
        break;
      case 'kari fry':
      case 'kary fry':
      case 'kee fry':
        window.location = '/collections/kari-fry';
        break;
      case 'keychains':
      case 'key chains':
        window.location = '/collections/keychains';
        break;
      case 'klei':
      case 'klei entertainment':
        window.location = '/collections/klei';
        break;
      case 'lapel pins':
      case 'lapels':
      case 'pins':
        window.location = '/collections/lapel-pins';
        break;
      case 'lovers in a dangerous spacetime':
      case 'lovers in a dangerous space time':
        window.location = '/collections/lovers-in-a-dangerous-spacetime';
        break;
      case 'luftrausers':
        window.location = '/collections/luftrausers';
        break;
      case 'magical game time':
      case 'zac gorman':
        window.location = '/collections/magical-game-time';
        break;
      case 'meatbun':
      case 'meat bun':
        window.location = '/collections/meatbun';
        break;
      case 'melissa king':
        window.location = '/collections/melissa-king';
        break;
      case 'coffee mugs':
      case 'mugs':
        window.location = '/collections/mugs';
        break;
      case 'music':
        window.location = '/collections/music';
        break;
      case 'mustin':
      case 'mustin enterprises':
        window.location = '/collections/mustin';
        break;
      case 'necrodancer':
      case 'crypt of the necrodancer':
        window.location = '/collections/necrodancer';
        break;
      case 'nitw':
      case 'night in the woods':
        window.location = '/collections/night-in-the-woods';
        break;
      case 'nucular throne':
      case 'nuclear throne':
        window.location = '/collections/nuclear-throne';
        break;
      case 'octodad':
      case 'octo dad':
        window.location = '/collections/octodad';
        break;
      case 'odd looking bird':
      case 'odd-looking bird':
      case 'ashley davis':
      case 'sprout snout':
      case 'sproutsnout':
        window.location = '/collections/odd-looking-bird';
        break;
      case 'omocat':
        window.location = '/collections/omocat';
        break;
      case 'hats':
      case 'socks':
        window.location = '/collections/misc-apparel';
        break;
      case 'papers please':
      case 'papers, please':
        window.location = '/collections/papers-please';
        break;
      case 'persona 5':
        window.location = '/collections/persona-5';
        break;
      case 'polos':
      case 'polo shirts':
        window.location = '/collections/polos';
        break;
      case 'polygon':
        window.location = '/collections/polygon';
        break;
      case 'posters':
        window.location = '/collections/posters';
        break;
      case 'psychonauts':
        window.location = '/collections/psychonauts';
        break;
      case 'screenprints':
      case 'screen prints':
        window.location = '/collections/screen-prints';
        break;
      case 'shovel knight':
        window.location = '/collections/shovel-knight';
        break;
      case 'space coyote':
      case 'space coyotl':
      case 'nina matsumoto':
        window.location = '/collections/space-coyote';
        break;
      case 'spelunky':
        window.location = '/collections/spelunky';
        break;
      case 'star dew valley':
      case 'stardew valley':
        window.location = '/collections/stardew-valley';
        break;
      case 'stickers':
        window.location = '/collections/stickers';
        break;
      case 'super time force':
        window.location = '/collections/super-time-force';
        break;
      case 't-shirts':
      case 't shirts':
      case 'tshirts':
        window.location = '/collections/t-shirts';
        break;
      case 'tanks':
      case 'tank tops':
      case 'tanktops':
        window.location = '/collections/tank-tops';
        break;
      case 'towerfall':
      case 'tower fall':
        window.location = '/collections/towerfall';
        break;
      case 'video':
      case 'videos':
      case 'movies':
        window.location = '/collections/video';
        break;
      case 'vlambeer':
        window.location = '/collections/vlambeer';
        break;
      case 'venus patrol':
        window.location = '/collections/vp-featured';
        break;
      case 'downwell':
      case 'down well':
        window.location = '/collections/downwell';
        break;
      case 'gunvolt':
      case 'azure striker gunvolt':
        window.location = '/collections/azure-striker-gunvolt';
        break;
      case 'y2k':
      case 'yiik':
        window.location = '/collections/yiik-a-post-modern-rpg';
        break;
      case 'star mazer':
      case 'starr mazer':
        window.location = '/collections/starr-mazer';
        break;
      case 'thimbleweed park':
      case 'thimble weed park':
        window.location = '/collections/thimbleweed-park';
        break;
      case 'severed':
        window.location = '/collections/severed';
        break;
      case 'halcyon 6':
        window.location = '/collections/halcyon-6';
        break;
      case 'gungeon':
      case 'enter the gungeon':
        window.location = '/collections/enter-the-gungeon';
        break;
      case 'shantae':
        window.location = '/collections/shantae';
        break;
      case 'samurai gunn':
      case 'samurai gun':
        window.location = '/collections/samurai-gunn';
        break;
      case 'rogue legacy':
        window.location = '/collections/rogue-legacy';
        break;
      case 'celeste':
        window.location = '/collections/celeste';
        break;
      case 'dark souls':
      case 'dark soul':
        window.location = '/collections/dark-souls';
        break;
      case 'myst':
        window.location = '/collections/myst';
        break;
      default:
        // creates a hidden 'q' field to submit query with added wildcard asterisks
        input.removeAttr('name'); // remove the original name, so it isn't submitted
        var newInput = $("<input type='hidden' name='q' value=''>");
        newInput.appendTo($(this));
        var words = term.split(" ");
        var fuzzyTerm = "";
        $.each(words, function(i, word) {
          fuzzyTerm += '*' + word + '* ';
        });
        fuzzyTerm = fuzzyTerm.trim();
        newInput.val(fuzzyTerm); // replace with 'term' for non-fuzzy search
        this.submit();
    }
  });

  // size charts, the lazy and semi-automatic way
  if (window.location.hostname == 'www.fangamer.com' || window.location.hostname == 'jp.fangamer.com' || window.location.hostname == 'www.fangamer.eu' || window.location.hostname == 'fangamer.eu') {
    $("td:contains('American Apparel 2001')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/2001_size_chart.png?7687802939493390520" class="fancybox"></a>');
    });
    $("td:contains('American Apparel BB401')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/BB401_size_chart.png?7687802939493390520" class="fancybox"></a>');
    });
    $("td:contains('Comfort Colors 1717')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/CC1717_Unisex_Shirt-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('Comfort Colors 6014')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/CC6014_Longsleeve_Shirt-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('Canvas 3001')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/Canvas_3001_Unisex_Shirt-fs8.png?v=1623965582" class="fancybox"></a>');
      $(this).append('<div class="product-feature" data-toggle="tooltip" data-title="100% Cotton"><img src="https://cdn.shopify.com/s/files/1/0014/1962/files/FG_icon_blend_100cotton_01.svg?v=1616801828" class="product-feature-icon injectable" /><span class="product-feature-title">100% Cotton</span></div>');
    });
    $("td:contains('Canvas 3021')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/Canvas_3021-fs8.png?v=1633659253" class="fancybox"></a>');
    });
    $("td:contains('Canvas 3200')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/Canvas_3200_Longsleeve-fs8.png?v=1623965583" class="fancybox"></a>');
    });
    $("td:contains('Canvas 3501')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/Canvas_3501_Longsleeve-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('Canvas 3650')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/Canvas_3650_Unisex_Shirt-fs8.png?v=1623965583" class="fancybox"></a>');
    });
    $("td:contains('Canvas 3901')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/Canvas_3901_Longsleeve-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('DM104L')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/DM104L_Women_s_Shirt-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('DM108')").each(function() {
      if ($(this).html().indexOf('L') !== -1) {
        $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/DM108L_Women_s_Shirt-fs8.png?v=1623965582" class="fancybox"></a>');
      } else {
        $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/DM108_Unisex_Shirt-fs8.png?v=1623965583" class="fancybox"></a>');
      }
    });
    $("td:contains('DM1170L')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/DM1170L_Women_s_Shirt-fs8.png?v=1623965583" class="fancybox"></a>');
    });
    $("td:contains('DT6000')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/DT6000_Unisex_Shirt-fs8.png?v=1623965583" class="fancybox"></a>');
    });
    $("td:contains('Gildan 18500')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/Gildan_18500_Hoodie-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('Gildan 18600')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/Gildan_18600_Hoodie-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('Gildan 2400')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/Gildan_2400_Shirt-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('Gildan 5000')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/Gildan_5000-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('LAT 6901')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/LATsize.jpg?v=1636052080" class="fancybox"></a>');
    });
    $("td:contains('LAT 3580')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/LATsize.jpg?v=1636052080" class="fancybox"></a>');
    });
    $("td:contains('IND4000')").each(function() {
      if ($(this).html().indexOf('Z') !== -1) {
        $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/IND4000Z_Hoodie-fs8.png?v=1623965582" class="fancybox"></a>');
      } else {
        $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/IND4000_v2-fs8.png?v=1642212842" class="fancybox"></a>');
      }
    });
    $("td:contains('AFX4000')").each(function() {
      if ($(this).html().indexOf('Z') !== -1) {
        $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/ITC_AFX4000Z_Hoodie-fs8.png?v=1623965582" class="fancybox"></a>');
      } else {
        $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/ITC_AFX4000_Hoodie-fs8.png?v=1623965582" class="fancybox"></a>');
      }
    });
    $("td:contains('AFX90UN')").each(function() {
      if ($(this).html().indexOf('Z') !== -1) {
        $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/ITC_AFX90UNZ_Hoodie-fs8.png?v=1623965583" class="fancybox"></a>');
      } else {
        $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/ITC_AFX90UN_Hoodie-fs8.png?v=1623965582" class="fancybox"></a>');
      }
    });
    $("td:contains('EXP70PTZ')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/ITC_EXP70PTZ_Hoodie-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('IND45UVZ')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/ITC_IND45UVZ_Hoodie-fs8.png?v=1623965583" class="fancybox"></a>');
    });
    $("td:contains('PRM30SBC')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/ITC_PRM30SBC_Shirt-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('SS4500Z')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/ITC_SS4500Z_Hoodie-fs8.png?v=1623965583" class="fancybox"></a>');
    });
    $("td:contains('PRM90HTZ')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/ITC_PRM90HTZ_Hoodie-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('evel 3600'), td:contains('evel NL3600')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/NL3600_Unisex_Shirt-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('evel 3900'), td:contains('evel NL3900')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/NL3900_Women_s_Shirt-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('evel 6210'), td:contains('evel NL6210')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/NL_6210_Unisex_Shirt-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('Company 61'), td:contains('Company PC61')").each(function() {
      if ($(this).html().indexOf('LS') !== -1) {
        $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/PC61LS_Shirt-fs8.png?v=1623965582" class="fancybox"></a>');
      } else {
        $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/P_C_61_Shirt-fs8.png?v=1623965582" class="fancybox"></a>');
      }
    });
    $("td:contains('Company 78'), td:contains('Company PC78')").each(function() {
      if ($(this).html().indexOf('Z') !== -1) {
        $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/PC78ZH_Hoodie-fs8.png?v=1623965582" class="fancybox"></a>');
      } else if ($(this).html().indexOf('H') !== -1) {
        $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/PC78H_Hoodie-fs8.png?v=1623965582" class="fancybox"></a>');
      } else {
        $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/PC_78-fs8.png?v=1633659253" class="fancybox"></a>');
      }
    });
    $("td:contains('Company 450'), td:contains('Company PC450')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/PC450_Unisex_Shirt-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    $("td:contains('Company 55P'), td:contains('Company PC55P')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/PC_55P-fs8.png?v=1633659253" class="fancybox"></a>');
    });
    $("td:contains('PC90ZH')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/PC90ZH_Hoodie-fs8.png?v=1623965583" class="fancybox"></a>');
    });
    $("td:contains('PRM90HT')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/PRM90HT_Hoodie-fs8.png?v=1623965583" class="fancybox"></a>');
    });
    $("td:contains('PRM33SBZ')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/PRM33SBZ-fs8-fs8.png?v=1633797957" class="fancybox"></a>');
    });
    $("td:contains('SS4500')").each(function() {
      $(this).wrapInner('<a href="https://cdn.shopify.com/s/files/1/0014/1962/files/SS4500_Hoodie-fs8.png?v=1623965582" class="fancybox"></a>');
    });
    SVGInject(document.querySelectorAll('img.injectable'));
    $('[data-toggle="tooltip"]').tooltip();
  }

  $('.glitchbux').each(function() {
    var random_start = Math.floor(Math.random() * 8000);
    $(this).css('animationDelay', '-' + random_start + 'ms');
  });
});

$(document).on('shopify:section:load', function(e) {
  SVGInject(document.querySelectorAll('img.injectable'));
});
$(document).on('shopify:section:reorder', function(e) {
  SVGInject(document.querySelectorAll('img.injectable'));
});
